// extracted by mini-css-extract-plugin
export default {"small":"separator-module__small--s9wYm","big":"separator-module__big--Qh9p_"};